import React, { useState, useEffect } from 'react';
import { catalog } from '../../utils/schemas';
import ApiServices from '../../utils/apiServices';
import Loading from '../../components/loading';
import { Empty } from 'antd';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

export default function Catalog() {
  const { getList } = ApiServices();
  const [catalogPDF, setCatalogPDF] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  function getCatalogPDF() {
    setIsLoading(true);
    getList(catalog)
      .then((response) => {
        console.log('response', response);
        setCatalogPDF(response.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching catalog:', err);
        setCatalogPDF([]);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getCatalogPDF();
  }, []);

  return (
    <div style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
      {isLoading ? (
        <Loading description="กำลังโหลด" />
      ) : catalogPDF.length > 0 ? (
        catalogPDF.map((pdf, index) => {
          console.log("PDF URL:", pdf.pdf_url);
          return <div key={index} style={{ marginBottom: '20px', height: '800px', width: '100%' }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              <Viewer fileUrl={pdf.pdf_url[0]} />
            </Worker>
          </div>
        })
      ) : (
        <Empty description="ไม่มีไฟล์ PDF" />
      )}
    </div>
  );
}